import { Wrapper } from 'AppReact';
import styled from 'styled-components';

export default Wrapper(styled.div``)